(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventDetailController', EventDetailController);

    EventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Event', 'EventStatus', 'Employee', 'EventCategoryType', 'EventCustomerSector', 'EventSchedule'];

    function EventDetailController($scope, $rootScope, $stateParams, entity, Event, EventStatus, Employee, EventCategoryType, EventCustomerSector, EventSchedule) {
        var vm = this;
        vm.event = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:eventUpdate', function(event, result) {
            vm.event = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
